export const getColor = (xValue: number) => {
  if (xValue >= 0 && xValue <= 0.29) {
    return '#642772';
  } else if (xValue >= 0.3 && xValue <= 0.34) {
    return '#ab216f';
  } else if (xValue >= 0.35 && xValue <= 0.39) {
    return '#ea675d';
  } else if (xValue >= 0.4 && xValue <= 0.44) {
    return '#faad64';
  } else if (xValue >= 0.45 && xValue <= 0.49) {
    return '#f6d062';
  } else if (xValue >= 0.5 && xValue <= 0.54) {
    return '#d4c25d';
  } else if (xValue >= 0.55 && xValue <= 0.59) {
    return '#a1b972';
  } else if (xValue >= 0.6 && xValue <= 0.65) {
    return '#57b49e';
  } else if (xValue >= 0.65 && xValue <= 0.69) {
    return '#278f8a';
  }

  return '#2c6b77';
};
